"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Body_module_scss_1 = __importDefault(require("./Body.module.scss"));
const Body = ({ children, className, ...rest }) => {
    const classes = (0, classnames_1.default)(Body_module_scss_1.default.content, className);
    return ((0, jsx_runtime_1.jsx)("tbody", { className: classes, ...rest, children: children }));
};
exports.default = Body;
